import getDiscountAmount from "./getDiscountAmount";
import hasDiscount from "./hasDiscount";

function getDiscountOffer({
  offer_amount = 0,
  order_amount = 0,
  canDiscount = true
}) {
  if (canDiscount && hasDiscount({ offer_amount, order_amount })) {
    const usedPoints = getDiscountAmount({
      offer_amount,
      order_amount
    });

    return {
      amountAfterDiscount: offer_amount - usedPoints,
      usedAffiliatePoints: usedPoints
    };
  }

  return {
    amountAfterDiscount: offer_amount,
    usedAffiliatePoints: 0
  };
}

export default getDiscountOffer;
